import { render, staticRenderFns } from "./solicitudes.vue?vue&type=template&id=13a07aee"
import script from "./solicitudes.vue?vue&type=script&lang=js"
export * from "./solicitudes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports